import { FC } from 'react';

import { AuthorizationRequired } from 'components/common/AuthorizationRequired';

import authorizationRequiredImg from './images/authorization-demand.png';

import css from './UnauthorizedNotification.module.scss';

export const BecomeSpeakerUnauthorizedNotification: FC = () => {
  return (
    <div className={css.authorizationRequiredWrapper}>
      <AuthorizationRequired img={authorizationRequiredImg}>
        Регистрируйтесь и подавайте заявку, чтобы стать лектором Российского
        общества "Знание". Стать лектором может каждый абсолютно бесплатно!
      </AuthorizationRequired>
    </div>
  );
};
